// MIGRATION STATUS CONSTANTS
export const COMMENTING_2_0_ACTIVATION_READY = 'COMMENTING_2_0_ACTIVATION_READY'
export const DATA_MIGRATION_READY = 'DATA_MIGRATION_READY'
export const DATA_MIGRATION_STARTED =  'DATA_MIGRATION_STARTED'
export const DATA_MIGRATION_PROGRESS = 'PROGRESS'
export const DATA_MIGRATION_ERROR = 'ERROR' 
export const DATA_MIGRATION_DONE = 'DONE' 
export const DATA_MIGRATION_CONFIRMED = 'CONFIRMED'
export const DATA_MIGRATION_NONE = 'NONE'